import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Hook to fetch the set of Pokemon valid for a specific VGC format.
 * Returns a Set of lowercase Pokemon names from Smogon stats.
 * Returns null when no format is selected (= no filter applied).
 */
const useFormatPokemon = (format) => {
  const [pokemonNames, setPokemonNames] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!format) {
      setPokemonNames(null);
      setError(null);
      return;
    }

    let cancelled = false;

    const fetchPokemon = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `/api/pokemon-by-format?format=${encodeURIComponent(format)}`
        );

        if (!cancelled) {
          const names = new Set(
            (response.data.pokemon || []).map(p => p.name.toLowerCase())
          );
          setPokemonNames(names.size > 0 ? names : null);
        }
      } catch (err) {
        if (!cancelled) {
          console.error('Error fetching Pokemon by format:', err);
          setError(err.message);
          setPokemonNames(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchPokemon();

    return () => { cancelled = true; };
  }, [format]);

  return { pokemonNames, loading, error };
};

export default useFormatPokemon;
